import React, { useEffect, useRef } from 'react';
import { useRouteMatch } from 'react-router-dom';

const Footer = () => {
  const el = useRef();
  const isAssignmentPg = useRouteMatch('/app/assignments/:_id');

  useEffect(() => {
    const tmpl = document.querySelector('template#footer-tmpl');

    if (tmpl) {
      el.current.innerHTML = tmpl.innerHTML;
    }
  }, []);

  return (
    <div
      ref={el}
      className={isAssignmentPg ? 'd-none d-md-block' : ''}
    ></div>
  );
};

export default Footer;
